// Scribe's deadline is the only owner of the dictation limit; without one the
// dictation shows no countdown.
export const getDictationRemainingSeconds = ({
  deadlineAt,
  now,
}: {
  deadlineAt: string | null;
  now: number;
}) => {
  const deadline = deadlineAt ? Date.parse(deadlineAt) : Number.NaN;
  return Number.isFinite(deadline)
    ? Math.max(0, Math.ceil((deadline - now) / 1000))
    : null;
};
